import { buildWorkflowTimeline } from '../streaming/buildWorkflowTimeline.js'
import { GCP_HOSTING_DEPLOY_AI_LOG_STEPS } from './gcpHostingDemoContent.part05.js'

export function gcpHostingDeployLogBlock(opts = {}) {
  const streaming = opts.streaming ?? false
  return {
    type: 'aiResponseLog',
    status: 'ok',
    showLogStatus: false,
    ...(streaming
      ? { stepTemplates: GCP_HOSTING_DEPLOY_AI_LOG_STEPS }
      : { steps: buildWorkflowTimeline(GCP_HOSTING_DEPLOY_AI_LOG_STEPS) }),
  }
}

/**
 * @param {{ streaming?: boolean }} [opts]
 * @returns {object[]}
 */
